import config from '../config.json';
import { getScreenWidth } from '../utils/getScreenWidth.js';
import DropdownHandler from './DropdownHandler.js';
import { createLinks, LINKS_TYPE } from './navbarLinks.js';

const ELEMENT_CLASSES = {
  DOT_VISIBLE: 'ds-header__navbar__avatar__btn_img--dotVisible',
  DOT_ALLOWED: 'ds-header__navbar__avatar__btn_img--dotAllowed',
};

export function createImg({ src, className }) {
  const img = document.createElement('img');
  img.classList.add(`${className}__img`);
  img.classList.add('select-none');
  img.alt = ''; // not required
  img.src = src;
  img.width = 32;
  img.height = 32;
  img.id = 'profilePicture';
  img.draggable = false;
  return img;
}

function createMobileToggleIcons({ parentClass }) {
  if (typeof parentClass !== 'string') {
    throw new Error('Invalid parentClass');
  }

  const toggleWrapper = document.createElement('span');
  toggleWrapper.classList.add(`${parentClass}__toggle`);

  const openMenuIcon = document.createElement('span');
  openMenuIcon.classList.add(`${parentClass}__toggle--open`);
  toggleWrapper.appendChild(openMenuIcon);

  const closeMenuIcon = document.createElement('span');
  closeMenuIcon.classList.add(`${parentClass}__toggle--close`);
  toggleWrapper.appendChild(closeMenuIcon);

  return toggleWrapper;
}

function createAvatarImage({ avatar: avatarUrl, initials, profilePicturePlaceholderConfig = {}, parentClass, dotAllowed = false, showDot = false }) {
  const btnWrapper = document.createElement('span');
  btnWrapper.classList.add(`${parentClass}__btn_img`);

  if (dotAllowed) {
    btnWrapper.classList.add(ELEMENT_CLASSES.DOT_ALLOWED);

    if (showDot) {
      btnWrapper.classList.add(ELEMENT_CLASSES.DOT_VISIBLE);
    }
  }

  if (initials && profilePicturePlaceholderConfig) {
    btnWrapper.dataset.initials = initials;
    btnWrapper.dataset.background = profilePicturePlaceholderConfig.background;
    btnWrapper.dataset.color = profilePicturePlaceholderConfig.text;
  }

  const imgClass = `${parentClass}__img`;

  if (avatarUrl) {
    btnWrapper.appendChild(createImg({
      src: avatarUrl,
      className: imgClass,
    }));
    return btnWrapper;
  }

  if (initials) {
    btnWrapper.appendChild(document.createTextNode(initials));
    btnWrapper.dataset.initials = initials;

    if (profilePicturePlaceholderConfig) {
      btnWrapper.style.backgroundColor = profilePicturePlaceholderConfig.background;
      btnWrapper.style.color = profilePicturePlaceholderConfig.text;

      btnWrapper.dataset.background = profilePicturePlaceholderConfig.background;
      btnWrapper.dataset.color = profilePicturePlaceholderConfig.text;
    }

    return btnWrapper;
  }

  btnWrapper.appendChild(createImg({
    src: config.GUEST_AVATAR_PATH,
    className: imgClass,
  }));

  return btnWrapper;
}

function createAvatarDropdown({ className, links }) {
  const dropdown = document.createElement('div');
  dropdown.classList.add(className);
  dropdown.appendChild(createLinks({
    links,
    linksType: LINKS_TYPE.DROPDOWN_NAV,
  }));

  return dropdown;
}

function createDropdownHandler({ className }) {
  const btnWrapper = document.createElement('span');
  btnWrapper.classList.add(className);

  return btnWrapper;
}

function createUserName({ className, userName }) {
  const name = document.createElement('div');
  name.classList.add(className);
  name.appendChild(document.createTextNode(userName));
  name.id = 'userName';
  return name;
}

function createAvatarWithDropdown({ className, user, dotAllowed, showDot, showUserName = false, showHandlerArrow = true }) {
  const avatarDropdown = document.createElement('div');
  avatarDropdown.classList.add(className);

  if (user.type === 'guest') {
    avatarDropdown.classList.add(`${className}--guest`);
  }

  avatarDropdown.appendChild(createMobileToggleIcons({
    parentClass: className,
  }));

  avatarDropdown.appendChild(createAvatarImage({
    parentClass: className,
    avatar: user.avatar,
    initials: user.initials,
    profilePicturePlaceholderConfig: user.profilePicturePlaceholderConfig,
    dotAllowed,
    showDot,
  }));

  if (user.fullName && showUserName) {
    avatarDropdown.appendChild(createUserName({
      className: `${className}__name`,
      userName: user.fullName,
    }));
  }
  if (showHandlerArrow) {
    avatarDropdown.appendChild(createDropdownHandler({
      className: `${className}__handler`,
    }));
  }

  return avatarDropdown;
}

export function createAvatarWrapper({ user, className, links, dotAllowed, showDot }) {
  const avatarWrapper = document.createElement('button');
  avatarWrapper.setAttribute('aria-label', 'Expand');
  avatarWrapper.classList.add(`${className}-wrapper`);

  avatarWrapper.appendChild(createAvatarWithDropdown({
    className,
    user,
    dotAllowed,
    showDot,
    showUserName: false,
    showHandlerArrow: false,
  }));

  const dropdown = createAvatarDropdown({
    className: `${className}__dropdown`,
    links,
  });

  avatarWrapper.appendChild(dropdown);

  const isMobile = getScreenWidth() < 768;
  new DropdownHandler({
    wrapper: avatarWrapper,
    dropdown,
    wrapperClassName: `${className}--open`,
    maximumHeight: isMobile ? `${window.innerHeight - config.MAX_HEADER_HEIGHT_MOBILE}px` : '600px',
    isMobile,
  }).startListening();

  return avatarWrapper;
}

export function updateAvatarImageDot(count) {
  // DOT_ALLOWED class is added only on mobile
  const btnWrapper = document.querySelector(`.${ELEMENT_CLASSES.DOT_ALLOWED}`);
  if (!btnWrapper) return;

  if (count > 0) {
    btnWrapper.classList.add(ELEMENT_CLASSES.DOT_VISIBLE);
  } else {
    btnWrapper.classList.remove(ELEMENT_CLASSES.DOT_VISIBLE);
  }
}
